const resources = {
    sponsored: 'Commandité',
    alt: 'Image de bannière avec contenu sponsorisé',
    moreToChooseFrom: 'Plus de choix'
};

module.exports = function getResource(label) {
    return resources[label];
};
